import $ from 'jquery';
// import * as modalUtils from './modalUtils';

export function handleAjaxError() {
	$(document).ajaxError((error, jqXHR) => {
		switch (jqXHR.status) {
			case 401:
				const renderURL = '/donate/buttons/login?returnUri=/buttons';
				// Need to do in this way because window.location.href doesn't update referer in http req header
				window.history.pushState(null, null, renderURL);
				location.reload();
				break;

			default:
				break;
		}
	});
}



// WEBPACK FOOTER //
// ./buttons/utils/globalHandler.js